import { ManagerConnector } from "./managerConnector"
import { DResourceManager, createResourceManager, IEBResourceManager } from "./resourceManager"
import { SwarmManager, IEBSwarmManager } from "./swarmManager"
import { IStatsCollector, IStatsInputPlugin, createStatsCollector, IStatsOutputPlugin } from "./statsCollectors"
import { manager } from "./protos/eb.manager"
import { peers } from "./protos/eb.peers"
import { EBXMLHttpRequest } from "./ebXMLHttpRequest"
import { Subject, config } from "rxjs"
import { ManagerOutputPlugin } from "./contrib/managerOutputPlugin"
import { NetworkInfoPlugin } from "./contrib/networkInfoPlugin"
declare global {
  interface Window { conflib: any}
}
window.conflib = window.conflib || {
  log: {},
}

const VERSION = "v1.4.7"
class EBLibrary {
  private mc: ManagerConnector
  private sm: SwarmManager
  private rm: IEBResourceManager
  private sc: IStatsCollector
  private mcout: ManagerOutputPlugin
  private niout: NetworkInfoPlugin
  private started = false
  public constructor(url: string) {
    console.info(`Easybroadcast Technology ${VERSION}. All rights reserved.`)
    this.mc = ManagerConnector.session().assign(url).start()
    this.sm = SwarmManager.new().bind(this.mc)
    this.rm = createResourceManager().bindSwarmManager(this.sm)
    this.mcout = new ManagerOutputPlugin().setLibVersion(VERSION)
    this.sc = createStatsCollector()
    this.niout = new NetworkInfoPlugin()
  }
  public getResourceManager = (): IEBResourceManager => {
    return this.rm
  }

  public getSwarmManager = (): IEBSwarmManager => {
    return this.sm
  }

  public register = (bandwidth: number, codec: string, url: string, clean: boolean = false): Promise<boolean> => {
    return this.sm.register(bandwidth, codec, url, clean)
  }
  public registerStatsInputPlugin = (plugin: IStatsInputPlugin): EBLibrary => {
    this.sc.register(plugin)
    return this
  }
  public registerStatsOutputPlugin = (plugin: IStatsOutputPlugin, name: string): EBLibrary => {
    this.sc.registerOutput(plugin, name)
    return this
  }
  public getResource = (url: string, timeout: number = 10000, fetchSetup?: RequestInit): Promise<Uint8Array> => {
    return this.rm.getResource(url, timeout, fetchSetup)
  }
  public createEBXHR = (): EBXMLHttpRequest => {
    const xhr = new EBXMLHttpRequest().bindResourceManager(this.rm)
    return xhr
  }
  public setTimeoutV2V = (to: number): EBLibrary => {
    this.rm.setTimeoutV2V(to)
    return this
  }
  public start = (): void => {
    if (this.started) {
      console.warn("Shouldn't have start the lib twice")
      return
    }
    this.sm.start(4000)
    this.registerStatsInputPlugin(this.sm).registerStatsInputPlugin(this.rm).registerStatsInputPlugin(this.niout)
    this.registerStatsOutputPlugin(this.mcout.bindManagerConnector(this.mc).setLibVersion(VERSION).start(), "websocket")
    this.niout.start()
    this.started = true
  }
  public close = (): void => {
    this.started = false
    this.mc.close()
    this.sm.close()
    this.sc.close()
    this.mc = null
    this.sm = null
    this.sc = null
  }
}

export {
  manager,
  peers,
  EBLibrary,
  Subject,
  VERSION,
}
